export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2016.47d88e98.pdf";